module.exports = __webpack_public_path__ + "img/facebook-logo.3ea48b79.svg";